"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumnWidthFix = exports.TableTabletHiddenStyles = exports.TableMobileHiddenStyles = exports.TableTypeEnum = exports.OrderTypeEnum = exports.TableFilterType = void 0;
var TableFilterType;
(function (TableFilterType) {
    TableFilterType["Searchable"] = "searchable";
    TableFilterType["Filterable"] = "filterable";
})(TableFilterType || (exports.TableFilterType = TableFilterType = {}));
var OrderTypeEnum;
(function (OrderTypeEnum) {
    OrderTypeEnum[OrderTypeEnum["Ascending"] = 0] = "Ascending";
    OrderTypeEnum[OrderTypeEnum["Descending"] = 1] = "Descending";
})(OrderTypeEnum || (exports.OrderTypeEnum = OrderTypeEnum = {}));
var TableTypeEnum;
(function (TableTypeEnum) {
    TableTypeEnum["Documents"] = "documents";
    TableTypeEnum["Approvals"] = "approvals";
    TableTypeEnum["Software"] = "software";
    TableTypeEnum["Learning"] = "learning";
    TableTypeEnum["Drawings"] = "drawings";
})(TableTypeEnum || (exports.TableTypeEnum = TableTypeEnum = {}));
var TableMobileHiddenStyles;
(function (TableMobileHiddenStyles) {
    TableMobileHiddenStyles[TableMobileHiddenStyles["type"] = 0] = "type";
    TableMobileHiddenStyles[TableMobileHiddenStyles["software-characteristic"] = 1] = "software-characteristic";
    TableMobileHiddenStyles[TableMobileHiddenStyles["softwareCharacteristic"] = 2] = "softwareCharacteristic";
    TableMobileHiddenStyles[TableMobileHiddenStyles["expiration-date"] = 3] = "expiration-date";
    TableMobileHiddenStyles[TableMobileHiddenStyles["expirationDate"] = 4] = "expirationDate";
    TableMobileHiddenStyles[TableMobileHiddenStyles["file-type"] = 5] = "file-type";
    TableMobileHiddenStyles[TableMobileHiddenStyles["fileType"] = 6] = "fileType";
    TableMobileHiddenStyles[TableMobileHiddenStyles["learningType"] = 7] = "learningType";
    TableMobileHiddenStyles[TableMobileHiddenStyles["approval-authority"] = 8] = "approval-authority";
    TableMobileHiddenStyles[TableMobileHiddenStyles["approvalAuthority"] = 9] = "approvalAuthority";
    TableMobileHiddenStyles[TableMobileHiddenStyles["version"] = 10] = "version";
    TableMobileHiddenStyles[TableMobileHiddenStyles["updated"] = 11] = "updated";
    TableMobileHiddenStyles[TableMobileHiddenStyles["release-date"] = 12] = "release-date";
    TableMobileHiddenStyles[TableMobileHiddenStyles["releaseDate"] = 13] = "releaseDate";
})(TableMobileHiddenStyles || (exports.TableMobileHiddenStyles = TableMobileHiddenStyles = {}));
var TableTabletHiddenStyles;
(function (TableTabletHiddenStyles) {
    TableTabletHiddenStyles[TableTabletHiddenStyles["status"] = 0] = "status";
    TableTabletHiddenStyles[TableTabletHiddenStyles["language"] = 1] = "language";
    TableTabletHiddenStyles[TableTabletHiddenStyles["languages"] = 2] = "languages";
    TableTabletHiddenStyles[TableTabletHiddenStyles["learningType"] = 3] = "learningType";
    TableTabletHiddenStyles[TableTabletHiddenStyles["valid-for"] = 4] = "valid-for";
    TableTabletHiddenStyles[TableTabletHiddenStyles["validFor"] = 5] = "validFor";
})(TableTabletHiddenStyles || (exports.TableTabletHiddenStyles = TableTabletHiddenStyles = {}));
var TableColumnWidthFix;
(function (TableColumnWidthFix) {
    TableColumnWidthFix[TableColumnWidthFix["Updated"] = 0] = "Updated";
    TableColumnWidthFix[TableColumnWidthFix["updated"] = 1] = "updated";
    TableColumnWidthFix[TableColumnWidthFix["duration"] = 2] = "duration";
})(TableColumnWidthFix || (exports.TableColumnWidthFix = TableColumnWidthFix = {}));
